<template>
  <div class="body">
    <moduleTitle title="岗位列表"></moduleTitle>
    <p style="margin: 20px; font-size: 20px; font-weight: 700">{{ msg }}</p>

    <div class="selection">
      <div v-show="show" class="line">
        <!-- 内部公开招聘招聘岗位不再有招聘岗位类型属性-->
        <!-- <div class="label">招聘岗位类型</div>
        <div class="options">
          <div
            class="item"
            :class="{ active: optionIndex == indexA }"
            v-for="(item, optionIndex) in optionsA"
            :key="optionIndex"
            @click="optionClick(item, optionIndex)"
          >
            {{ item.value }}
          </div>
        </div> -->
      </div>
      <div v-show="!show" class="line">
        <div class="label">应聘版块</div>
        <div class="options">
          <div
            class="item"
            :class="{ active: optionIndexB == indexB }"
            v-for="(item, optionIndexB) in optionsB"
            :key="optionIndexB"
            @click="optionClickB(item, optionIndexB)"
          >
            {{ item.value }}
          </div>
        </div>
      </div>
    </div>
    <div>
      <postItem :postList="list" :zpgwlx="zpgwlx"></postItem>
    </div>
    <pagination
      :total="pagination.total"
      @currentPageChange="currentPageChange"
      @pageSizeChange="pageSizeChange"
    ></pagination>
  </div>
</template>
<style lang="scss" scoped>
@mixin content {
  padding: 3px 10px;
  margin: 0 10px;
  float: left;
}

.body {
  width: 80%;
  margin: 40px auto;

  .selection {
    .line {
      &:after {
        clear: both;
      }

      overflow: hidden;
      margin: 10px 0px 20px 0px;

      .label {
        font-weight: bold;
        width: 10%;
        @include content;
      }

      .options {
        width: 80%;
        float: left;

        .item {
          @include content;

          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
}

.active {
  border-radius: 5px;
  background-color: #2a8ae0;
  color: #ffffff;
}
</style>
<script>
import moduleTitle from "@/components/moduleTitle.vue";
import postItem from "./components/postItem.vue";
import pagination from "@/components/pagination";
import request from "@/api/postList.js";
import share from "@/assets/sharejs/share.js";
export default {
  name: "postList",
  components: {
    moduleTitle,
    postItem,
    pagination,
  },
  data() {
    return {
      zplb: "",
      msg: "",
      show: true,
      zphdlx: "",
      zphdid: "", // zphdlx = 1 zphdid = zpqsid;   zphdlx = 2 zphdid = zpjhid;
      zpgwlx: "001",
      ssbk: "0",
      list: [],
      pagination: {
        total: 0,
        page: 1,
        pageSize: 10,
      },
      indexA: 0,
      indexB: 0,
      indexC: 0,
      optionsA: [],
      optionsB: [],
      // optionsC: [
      //   { key: "1", value: "内部公开招聘" },
      //   { key: "2", value: "社会化招聘" }
      // ]
    };
  },
  mounted() {},
  created() {
    this.optionsA = share.get("zpgwlx");
    this.optionsB = share.get("ssbk");
    this.zphdid = this.$route.query.id;
    this.zphdlx = this.$route.query.zphdlx;
    this.zplb = this.$route.query.zplb;
    if (this.zphdlx == "2") {
      this.show = false;
    } else {
      this.show = true;
    }
    this.msg = this.$route.query.title;
    this.queryGwlb();
  },
  methods: {
    optionClick(item, optionIndex) {
      this.indexA = optionIndex;
      this.zpgwlx = item.key;
      this.queryGwlb();
    },
    optionClickB(item, optionIndexB) {
      this.indexB = optionIndexB;
      this.ssbk = item.key;
      this.queryGwlb();
    },
    // optionClickC(item, optionIndexC) {
    //   this.indexC = optionIndexC;
    //   this.zphdlx = item.key;
    //   if (item.key == "2") {
    //     this.show = false;
    //   } else {
    //     this.show = true;
    //   }
    //   this.queryGwlb();
    // },
    queryGwlb() {
      let para = {
        zphdlx: this.zphdlx,
        zphdid: this.zphdid,
        // zpgwlx: this.zpgwlx, 内部公开招聘招聘岗位去掉招聘岗位类型属性
        ssbk: this.ssbk,
        gwlb: "",
        gwlbid: "",
        page: this.pagination.page, //页码
        pageSize: this.pagination.pageSize, //每页显示的条数
      };
      request.queryGwlb(para).then((res) => {
        console.log('queryGwlb>>>', res);
        this.pagination.total = res.total;
        if (para.zphdlx == "1") {
          this.list = res.vds.map((item) => {
            return {
              zphdlx: para.zphdlx,
              zphdid: item.zpqsid,
              gwlbid: item.gwlbid,
              zphdmc: item.zphdmc,
              company: item.zpdw,
              post: item.gwmc,
              planNumber: item.jhrs,
              gwzz: item.gwzz,
              degreeLimit: item.xlyq,
              zyyq: item.zyyq,
              ageLimit: item.nlyq,
              zgtj: item.zgtj,
              zyjszg: item.zyjszg,
              zzjnjnlszyq: item.zzjnjnlszyq,
              yxtj: item.yxtj,
              xcdy: item.xcdy,
              gzdd: item.gzdd,
              zplb: this.zplb
            };
          });
        } else if (para.zphdlx == "2") {
          this.list = res.vds.map((item) => {
            return {
              zphdlx: para.zphdlx,
              zphdid: item.zpjhid,
              gwlbid: item.gwlbid,
              zphdmc: item.zphdmc,
              company: share.getValue("ssbk", item.zpdw),
              post: item.gwmc,
              planNumber: item.jhrs,
              gwzz: "",
              degreeLimit: "",
              zyyq: "",
              ageLimit: "",
              zgtj: "",
              zyjszg: "",
              zzjnjnlszyq: "",
              yxtj: item.yxtj,
              zptj: item.zptj,
              xcdy: item.xcdy,
              gzdd: item.gzdd,
              zplb: this.zplb
            };
          });
        }
      });
    },
    /**
     * 每页大小改变时，响应方法
     */
    pageSizeChange(e) {
      this.pagination.pageSize = e;
      this.pagination.page = 1;
      this.queryGwlb();
    },
    /**
     * 当前页变更时，响应方法
     */
    currentPageChange(e) {
      this.pagination.page = e;
      this.queryGwlb();
    },
  },
};
</script>
